import type { AppointmentInfo } from "@/types";
import { ezyvetRecordUrl, ezyvetSiteUrl, type EzyVetRecord } from "@/utils/ezyvetLinks";

interface Props {
  appointment: AppointmentInfo;
  site: string | null;
}

/** ezyVet ids for a synced appointment, linked to ezyVet where the record URL is known. */
export function EzyVetMeta({ appointment, site }: Props) {
  if (appointment.external_source !== "ezyvet") return null;
  const siteUrl = ezyvetSiteUrl(site);

  return (
    <div className="pms-meta" aria-label="ezyVet record">
      <IdChip label="Consult" kind="consult" id={appointment.external_id} site={site} />
      <IdChip label="Animal" kind="animal" id={appointment.external_animal_id} site={site} />
      {siteUrl && (
        <a className="btn btn-sm" href={siteUrl} target="_blank" rel="noopener noreferrer">
          Open ezyVet ↗
        </a>
      )}
    </div>
  );
}

function IdChip({ label, kind, id, site }: { label: string; kind: EzyVetRecord; id: string | null; site: string | null }) {
  if (!id) return null;
  const url = ezyvetRecordUrl(site, kind, id);
  const text = (
    <>
      {label} <span className="mono">#{id}</span>
    </>
  );
  return url ? (
    <a className="chip" href={url} target="_blank" rel="noopener noreferrer" title={`Open ${label.toLowerCase()} in ezyVet`}>
      {text} ↗
    </a>
  ) : (
    <span className="chip">{text}</span>
  );
}
